import { ArrowLeft, SearchX } from "lucide-react";
import { AppShell } from "./components/AppShell";
import { EmptyState } from "./components/States";
import { Link, Route, Routes } from "./lib/router";
import { InventoryPage } from "./pages/InventoryPage";
import { LocationsPage } from "./pages/LocationsPage";
import { WineDetailPage } from "./pages/WineDetailPage";
import { WineFormPage } from "./pages/WineFormPage";

function NotFoundPage() {
  return (
    <AppShell>
      <div className="page narrow-page">
        <EmptyState
          icon={<SearchX size={28} aria-hidden="true" />}
          title="Cette page n’existe pas"
          message="Revenez à l’inventaire pour retrouver vos bouteilles."
          action={
            <Link className="button button-primary" to="/">
              <ArrowLeft size={17} aria-hidden="true" /> Retour à ma cave
            </Link>
          }
        />
      </div>
    </AppShell>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<InventoryPage />} />
      <Route path="/epuises" element={<InventoryPage />} />
      <Route path="/emplacements" element={<LocationsPage />} />
      <Route path="/vins/nouveau" element={<WineFormPage key="new" />} />
      <Route path="/vins/:id" element={<WineDetailPage />} />
      <Route path="/vins/:id/modifier" element={<WineFormPage key="edit" />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
